<ng-container *appTranslate="let t">
  @for (exam of exams; track exam) {
    @if (readonly) {
      <new-ui-wrapper-readonly [label]="t('name.title')" [value]="exam.name" />

      <new-ui-wrapper-readonly
        [label]="t('passedExamModules.title')"
        [value]="exam.passedModules | enum: 'ExamModuleType'"
      />

      <new-ui-wrapper-readonly
        [label]="t('examDate.title')"
        [value]="
          exam.examDateAndTime?.hasTime
            ? (exam.examDateAndTime?.date | appDateTime)
            : (exam.examDateAndTime?.date | appDate)
        "
      />

      <new-ui-candidate-document-date
        [maskTabKey]="null"
        [maskFieldName]="null"
        #issueDate
        [candidateId]="candidateId"
        [candidateOrganizationId]="organizationId"
        [candidateForm]="form"
        [additionalForeignKeySourceData]="{ certifiedExams: exams }"
        [readonly]="readonly || disabled"
        [disabled]="disabled"
        [label]="t(languageSkillLabelMapping.examCertificateDate)"
        [documentType]="exam?.documentType"
        [selectedSet]="{ foreignKey: exam.examResultId }"
        [dt]="dt"
        dateField="issueDate"
        [showDocumentCompletion]="showDocumentCompletion"
      />
    } @else {
      <div class="form">
        <p-floatlabel [dt]="dt?.components?.floatlabel" [class.col-span-6]="!readonly" variant="in">
          <input pInputText [ngModel]="exam.name" [readonly]="true" [fluid]="true" />

          <label>
            {{ t("name.title") }}
          </label>
        </p-floatlabel>

        <p-floatlabel [dt]="dt?.components?.floatlabel" [class.col-span-6]="!readonly" variant="in">
          <input pInputText [ngModel]="exam.passedModules | enum: 'ExamModuleType'" [readonly]="true" [fluid]="true" />

          <label>
            {{ t("passedExamModules.title") }}
          </label>
        </p-floatlabel>

        <p-floatlabel [dt]="dt?.components?.floatlabel" [class.col-span-6]="!readonly" variant="in">
          <p-datepicker
            [dt]="dt?.components?.datepicker"
            [ngModel]="exam?.examDateAndTime?.date"
            [showTime]="exam?.examDateAndTime?.hasTime"
            [readonlyInput]="true"
            [showOnFocus]="false"
            [fluid]="true"
            appendTo="body"
          />

          <label>
            {{ t("examDate.title") }}
          </label>
        </p-floatlabel>

        <new-ui-candidate-document-date
          [maskTabKey]="null"
          [maskFieldName]="null"
          #issueDate
          [class.col-span-6]="!readonly"
          [candidateId]="candidateId"
          [candidateOrganizationId]="organizationId"
          [candidateForm]="form"
          [additionalForeignKeySourceData]="{ certifiedExams: exams }"
          [readonly]="readonly || disabled"
          [disabled]="disabled"
          [label]="t(languageSkillLabelMapping.examCertificateDate)"
          [documentType]="exam?.documentType"
          [selectedSet]="{ foreignKey: exam.examResultId }"
          [dt]="dt"
          dateField="issueDate"
          [showDocumentCompletion]="showDocumentCompletion"
        />
      </div>
    }
  }
</ng-container>
